module.exports = __webpack_public_path__ + "static/media/fly0258.c97de99f.webp";